export default __webpack_public_path__ + "static/media/pixeboy.399c4ef0.woff";